import React from 'react';
export const PreviewContext = React.createContext({
    imageMaxHeight: '',
    imageUrl: '',
    className: '',
    onClose: () => { },
});
//# sourceMappingURL=preview-context.js.map